"use client";

import * as React from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import { cn } from "@/lib/utils";
import { Chevron } from "@/components/icons";

const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Trigger
    ref={ref}
    className={cn(
      "flex h-10 w-full items-center justify-between rounded-xl border border-neutral-300 bg-white px-4 py-2 font-roboto text-neutral-600",
      "hover:border-secondary-500 hover:ring-[0.5px] hover:ring-inset",
      "focus:border-secondary-600 focus:outline-none",
      "rounded-tl-xl rounded-tr-xl",
      "data-[state=closed]:rounded-xl data-[state=closed]:border-b",
      "[&>span]:line-clamp-1",
      "data-[state=open]:rounded-b-none data-[state=open]:border-2 data-[state=open]:border-b-0 data-[state=open]:border-secondary-500 data-[state=open]:px-4",
      "group disabled:cursor-not-allowed disabled:border-neutral-500 disabled:bg-neutral-100 disabled:opacity-50",
      "group-[:has(div[data-side='top'])]:rounded-b-xl group-[:has(div[data-side='top'])]:border-b-2",
      "group-[:has(div[data-side='top'])]:rounded-t-none group-[:has(div[data-side='top'])]:border-t-0",
      className
    )}
    {...props}
  >
    {children}
    <SelectPrimitive.Icon asChild>
      <Chevron className="h-5 w-5 rotate-180 opacity-50 transition group-data-[state=open]:rotate-0" />
    </SelectPrimitive.Icon>
  </SelectPrimitive.Trigger>
));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;

export default SelectTrigger;
